import { TRACK, IDENTIFY, PAGE, LINKCLICK } from '../constants'
import DriftApi from '~/lib/apis/DriftApi'
import { AnalyticsHandlers } from '~/lib/analytics/handlers/types'

export default function (
    driftApi: DriftApi,
): Omit<AnalyticsHandlers, typeof LINKCLICK> {
    return {
        [IDENTIFY]({ userId, traits: { email, name } }) {
            driftApi.identify(userId, {
                email,
                name,
                userId,
            })
        },

        [TRACK]({ event, properties }) {
            driftApi.track(event, properties)
        },

        [PAGE]({ properties: { path } }, state) {
            const identity = state?.identity

            if (identity?.id) {
                const isDriftExcluded =
                    /^\/(workbench)|^\/(vendor)|^\/(admin)/.test(path)

                if (isDriftExcluded) {
                    driftApi.hide()
                } else {
                    driftApi.show()
                }
            }

            driftApi.page()
        },
    }
}
